import { api } from '@/shared/api'
import {
    SetMetricsDto,
    YandexCounter,
    YandexGoal,
    YandexProfile,
} from '@synapex/shared'

export const fetchAuthUrlYandex = async (
    siteId: number
): Promise<{ authUrl: string }> => {
    return await api.get(`/yandex/auth/${siteId}`)
}

export const fetchYandexProfile = async (
    siteId: number
): Promise<YandexProfile> => {
    return await api.get(`/yandex/profile/${siteId}`)
}

export const fetchYandexCounters = async (
    siteId: number
): Promise<YandexCounter[]> => {
    return await api.get(`/yandex/counters/${siteId}`)
}

export const fetchYandexGoals = async (
    siteId: number,
    counterId: number
): Promise<YandexGoal[]> => {
    return await api.get(`/yandex/goals/${siteId}/counter/${counterId}`)
}

export const setYandexMetrics = async (
    siteId: number,
    body: SetMetricsDto
): Promise<any> => {
    return await api.post(`/yandex/set-metrics/${siteId}`, body)
}

export const yandexLogout = async (siteId: number): Promise<undefined> => {
    await api.get(`/yandex/logout/${siteId}`)
}
